/**
 * Invalidate client-side slide image caches after reprocess.
 *
 * Slide ids are deterministic ({deckId}-{index padded}) so we can evict
 * without listing Cosmos when we know the deck's slide count.
 */

import { evictSlideImageCache } from "./hooks/use-slide-image-blob"
import { evictSlideThumbnailCache } from "./hooks/use-thumbnail-prefetch"

export function deterministicSlideId(deckId: string, slideIndex: number): string {
  return `${deckId}-${String(slideIndex).padStart(5, "0")}`
}

/** Clear cached blob URLs for every slide row in a deck (best-effort). */
export function evictDeckSlideCaches(deckId: string, slideCount: number): void {
  const count = Math.max(0, slideCount)
  for (let i = 0; i < count; i++) {
    const slideId = deterministicSlideId(deckId, i)
    evictSlideImageCache(slideId)
    evictSlideThumbnailCache(slideId)
  }
}
